import { CarrierModel } from '@/lib/models/carrier/types';

export const getCarrierName = (carrier: CarrierModel): string => {
  const shortName = carrier?.names?.short?.length ? carrier.names.short[0] : '';
  const longName = carrier?.names?.long?.length ? carrier.names.long[0] : '';
  return shortName || longName;
};
